import { cloneDeep } from "lodash";

const getLastNextStack = nextStack => {
  if (nextStack.length > 0) {
    return nextStack[nextStack.length - 1];
  }

  return null;
};

export const isAtFirstQuestion = (questionPath, questions) => {
  if (!Array.isArray(questions) || !questions.length) {
    return false;
  }

  return questionPath === questions[0].urlPath;
};

export const isItALastQuestion = (answer, nextStack) => {
  return (
    answer?.answers[0]?.nextQuestionId === "END" && !getLastNextStack(nextStack)
  );
};

export const hasAnsweredAllQuestions = (answers, nextStack) => {
  if (!answers.length) {
    return false;
  }

  // On F5 on email screen.
  if (answers.length === 1 && answers[0].email) {
    return false;
  }

  const lastAnswer = answers[answers.length - 1];
  if (!lastAnswer.answers.length) {
    return false;
  }

  return (
    lastAnswer.answers[0].nextQuestionId === "END" &&
    !getLastNextStack(nextStack)
  );
};

export const getNextQuestion = (
  nextStack,
  questionPath,
  assessment,
  answers,
  checkQuestionPath = true,
  checkReturnQuestionId = true
) => {
  const questions = assessment?.questions;

  if (
    !answers ||
    !Array.isArray(answers) ||
    !answers.length ||
    !Array.isArray(questions)
  ) {
    return undefined;
  }

  const lastAnswer = answers[answers.length - 1];
  const lastAnswerQuestionId = lastAnswer.questionId;
  const lastAnswerQuestion = questions.find(
    question => question._id === lastAnswerQuestionId
  );

  if (!lastAnswerQuestion) {
    return undefined;
  }

  // Question is not answered yet.
  // E.g. when no option is selected yet.
  if (checkQuestionPath) {
    if (lastAnswerQuestion.urlPath !== questionPath) {
      return undefined;
    }
  }

  let nextQuestionId = lastAnswer?.answers[0]?.nextQuestionId;

  if (nextQuestionId === "END" && checkReturnQuestionId) {
    const returnQuestionInfo = getLastNextStack(nextStack);
    if (returnQuestionInfo) {
      nextQuestionId = returnQuestionInfo.returnQuestionId;
    }
  }

  return (
    questions.find(question => question._id === nextQuestionId) || undefined
  );
};

export const getAnswerForCurrentQuestion = (answers, questionId) => {
  if (!answers.length || !questionId) {
    return undefined;
  }

  const lastAnswerIndex = answers.length - 1;
  const lastAnswer = answers[lastAnswerIndex];

  // Need to check questionId since answers might not
  // have the answer for current question if user didn't
  // select any answer yet.
  if (lastAnswer.questionId === questionId) {
    return lastAnswer;
  }

  return undefined;
};

export const getAnswerIndexForCurrentQuestion = (answers, questionId) => {
  if (!answers.length) {
    return -1;
  }

  const lastAnswerIndex = answers.length - 1;
  const lastAnswer = answers[lastAnswerIndex];

  // Need to check questionId since answers might not
  // have the answer for current question if user didn't
  // select any answer yet.
  if (lastAnswer.questionId === questionId) {
    return lastAnswerIndex;
  }

  return -1;
};

export const getLastAnsweredQuestion = (questions, answers) => {
  if (!answers || !Array.isArray(answers) || !answers.length) {
    return null;
  }

  const lastQuestionId = answers[answers.length - 1].questionId;
  return questions.find(question => question._id === lastQuestionId);
};

export const getSavedStateKey = (urlPath, baseUrl) => {
  const separator = urlPath[0] === "/" ? "" : "/";
  return `wwQuizState_${baseUrl}${separator}${urlPath}`;
};

export const saveAppState = (
  baseUrl,
  location,
  answers,
  profile,
  contact,
  nextStack,
  queryString
) => {
  delete profile.password;

  const state = {
    answers: cloneDeep(answers),
    profile: cloneDeep(profile),
    contact: cloneDeep(contact),
    nextStack: cloneDeep(nextStack),
    queryString: cloneDeep(queryString)
  };

  window.sessionStorage.setItem(
    getSavedStateKey(location.pathname, baseUrl),
    JSON.stringify(state)
  );
};

export const mergeAppState = (dataToMergeIn, location, baseUrl) => {
  let state = window.sessionStorage.getItem(
    getSavedStateKey(location.pathname, baseUrl)
  );

  if (!state) {
    state = {};
  } else {
    state = JSON.parse(state);
  }

  delete dataToMergeIn.password;

  const mergedState = {
    ...state,
    ...dataToMergeIn
  };

  window.sessionStorage.setItem(
    getSavedStateKey(location.pathname, baseUrl),
    JSON.stringify(mergedState)
  );
};

export const getPreviousPage = (answers, assessment) => {
  const lastQuestionId = answers?.[answers.length - 1]?.questionId;
  const from = assessment?.questions?.find(
    question => question._id === lastQuestionId
  )?.urlPath;

  return from;
};
